import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Structure, calc } from '@/common/helpers/structure.helper'
import { dataLink } from '@/common/interfaces/Links.interface'

@Component({})
export class FlagConfig extends Vue {

    public helper = new Structure();
    public qtdCharacters: number = 25;
    public itemData: dataLink;

    public colorsFlag = [
        {
            color: 'blue'
            ,icon: 'fas fa-font'
        },
        {
            color: 'red'
            ,icon: 'fas fa-font'
        },
        {
            color: 'pink'
            ,icon: 'fas fa-font'
        },
        {
            color: 'black'
            ,icon: 'fas fa-font'
        },
        {
            color: 'green'
            ,icon: 'fas fa-font'
        },
    ]

    @Prop({default: undefined})
    public data: dataLink;

    @Watch('data')
    onPropertyChanged(value: dataLink) {
        this.itemData = value;
    }
    
    created(){
        this.itemData = this.data;
    }

    public changeFlagColor(item: dataLink, color: string) {
        item.flag.class = color;
    }

    public closeModal(item: dataLink){
        if( item.flag.text == '' ){
            item.flag.class = 'green';
        }
        this.$emit('closeFlag', item);
    }

    public saveModal(item: dataLink){
        this.closeModal(item);
    }

    public manipulateClassCountTxt(item: dataLink, qtd: number){
        let percent: number = calc.porcentagem(qtd, 25);
        let classe: string = '';
        
        switch(true){
            case percent >= 60:
                classe = 'badge-success';
                break;
                
            case percent >= 30:
                classe = 'badge-warning';
                break;
                
            case percent >= 1:
                classe = 'badge-danger';
                break;

            case percent == 0:
                classe = 'badge-light';
                break;
        }
                
        item.flag.customClass = classe;
    }

}